import axiosInstance from "./axiosInstance";

export interface RegularWritebackPayload {
  plantId: string;
  fromDate: string;
  toDate: string;
  updatedBy?: string;
  action: "ADD" | "UPDATE" | "DELETE";
}

export interface WritebackDateRecord {
  id?: number | string;
  plant: string;
  fromDate: string;
  toDate: string;
  updatedBy?: string;
  updatedTimestamp?: string;
}

export interface WritebackHistoryRecord {
  id?: number | string;
  action?: string;
  plantId?: string;
  fromDate?: string;
  toDate?: string;
  updatedBy?: string;
  updatedTimestamp?: string;
}

export const getWritebackDatesApi = async (): Promise<WritebackDateRecord[]> => {
  try {
    const response = await axiosInstance.get("/api/admin/get-writeback-dates");
    return response.data;
  } catch (error) {
    console.error("Error fetching writeback dates:", error);
    throw error;
  }
};

export const getWritebackHistoryApi = async (
  plantId: string,
): Promise<WritebackHistoryRecord[]> => {
  try {
    const response = await axiosInstance.get(
      `/api/admin/get-writeback-history/${plantId}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching writeback history:", error);
    throw error;
  }
};

export const submitRegularWritebackApi = async (
  data: RegularWritebackPayload | RegularWritebackPayload[],
): Promise<any> => {
  try {
    const payload = Array.isArray(data) ? data : [data];
    const response = await axiosInstance.post(
      "/api/admin/regular-writeback",
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error submitting regular writeback:", error);
    throw error;
  }
};
